import 'angular-messages';
import 'angular-scroll';
const MODULE_NAME = 'termofoldKalkulator';
export default angular.module(MODULE_NAME, ['duScroll'])
	.controller('termofoldController', function ($document) {
		'ngInject';
		this.formData = window.formData;
		let formBottom = angular.element(document.getElementById('jzb-results'));
		if (formBottom.length) {
			$document.scrollToElementAnimated(formBottom);
		}
	}).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/termofoldkalkulator/termofoldkalkulator.js